import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill'

/**
 * This method, including className="custom-select-cc-emoji", is used to support country code emojis for chronium based browsers
 * @param data
 */
export const countryFlagEmojiSupport = () => polyfillCountryFlagEmojis()
